var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99169 16.342C3.13873 16.7129 3.17147 17.1193 3.08569 17.509L2.02069 20.799C1.98638 20.9658 1.99525 21.1387 2.04647 21.3011C2.09769 21.4636 2.18955 21.6103 2.31336 21.7273C2.43716 21.8443 2.5888 21.9277 2.75389 21.9697C2.91898 22.0116 3.09205 22.0107 3.25669 21.967L6.66969 20.969C7.03741 20.8961 7.41822 20.9279 7.76869 21.061C9.90408 22.0582 12.3231 22.2692 14.5988 21.6567C16.8746 21.0442 18.861 19.6477 20.2074 17.7134C21.5538 15.7791 22.1738 13.4314 21.958 11.0845C21.7422 8.73769 20.7044 6.54247 19.0278 4.88619C17.3511 3.22992 15.1434 2.21904 12.7941 2.0319C10.4448 1.84475 8.10483 2.49338 6.18713 3.86334C4.26944 5.23329 2.89722 7.23654 2.31258 9.51964C1.72795 11.8027 1.96846 14.219 2.99169 16.342Z",
    stroke: "#0071E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCircle);
export default __webpack_public_path__ + "static/media/message-circle.d5751503eb6abbc03332b3ec1f1c4788.svg";
export { ForwardRef as ReactComponent };